var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path, _path2, _polyline;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 20px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 946,
    y: 304,
    width: 99,
    height: 767,
    rx: 21.02,
    ry: 21.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 796,
    y: 453,
    width: 99,
    height: 618,
    rx: 21.02,
    ry: 21.02
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 640,
    y: 596,
    width: 99,
    height: 475,
    rx: 21.02,
    ry: 21.02
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 484,
    y: 708,
    width: 99,
    height: 363,
    rx: 21.02,
    ry: 21.02
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 328,
    y: 817,
    width: 99,
    height: 254,
    rx: 21.02,
    ry: 21.02
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172,
    y: 945,
    width: 99,
    height: 126,
    rx: 21.02,
    ry: 21.02
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 511.61,
    cy: 474.5,
    r: 134.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m501.97,575.94v-25.31c-14.53-.25-29.57-4.76-38.34-11.03l6.01-16.79c9.02,6.01,22.05,10.77,36.08,10.77,17.79,0,29.82-10.27,29.82-24.56s-9.77-22.3-28.31-29.82c-25.56-10.02-41.35-21.55-41.35-43.35s14.78-36.58,37.84-40.34v-25.31h15.54v24.31c15.04.5,25.31,4.51,32.58,8.77l-6.27,16.54c-5.26-3.01-15.54-8.52-31.57-8.52-19.29,0-26.56,11.53-26.56,21.55,0,13.03,9.27,19.55,31.07,28.57,25.81,10.52,38.84,23.55,38.84,45.86,0,19.8-13.78,38.34-39.59,42.6v26.06h-15.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m153.74,826s449.26-119.36,741.26-557.18"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "796 326 910 251 872 379.03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.7abbf4c300ed58bcf5e617fb81196d19.svg";
export { ForwardRef as ReactComponent };